// extracted by mini-css-extract-plugin
export default {"skipdatecontain":"PY","skip_info":"QY","skipped":"RY","modify_order":"SY","cancel_subscription_btn":"TY","byb":"UY","modify_order_outer":"VY","byb_edit_btn":"WY","modify_order_item":"XY","cancel_copy_wrapper":"YY","cancelled_copy":"ZY"};
    if(module.hot) {
      // 1743628929002
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  